import { useStaticQuery, graphql } from 'gatsby'
import { TrustpilotReview } from '@talentinc/gatsby-source-trustpilot-widget'

type TrustPilotReviewQuery = {
  allTrustpilotReview: {
    reviews: TrustpilotReview[]
  }
}

// useTrustPilotReviews returns all reviews that were fetched by the
// Trustpilot Widget source.
export default function useTrustPilotReviews(): TrustpilotReview[] {
  const data = useStaticQuery<TrustPilotReviewQuery>(
    graphql`
      query UseTrustPilotReviews {
        allTrustpilotReview {
          reviews: nodes {
            id
            displayName
            title
            text
            consumer {
              displayName
            }
            stars
            reviewTag
            createdAt
          }
        }
      }
    `
  )

  return data.allTrustpilotReview.reviews
}

export function useTrustPilotTaggedReviews(
  tagName: string,
  brandName?: string
): TrustpilotReview[] {
  const allReviews = useTrustPilotReviews()
  const brand = brandName?.includes('TopCV') ? 'TopCV' : brandName

  return allReviews
    .filter(({ displayName }) => brand === displayName)
    .filter(({ reviewTag }) => tagName === reviewTag)
}
